import { useLiveList } from './SocketContext';

/**
 * Is a given session live right now? (The live view itself lives at /live/:sessionId and
 * uses useLiveSessionState from SocketContext.)
 */
export function useIsSessionLive(sessionId) {
    const list = useLiveList();
    return !!sessionId && list.sessions.some((s) => s.sessionId === sessionId);
}
